import React from 'react';
import { Link, Route, Routes } from 'react-router-dom';
import { Button } from 'antd';
import { LeftCircleFilled } from '@ant-design/icons';
import OldLogin from '../pages/auth/OldLogin';
import OldRegister from '../pages/auth/OldRegister';

const AuthLayout = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
      <Link to="/">
        <Button type="primary" icon={<LeftCircleFilled />} style={{ position: 'fixed', top: 20, left: 20, zIndex: 1000 }}>Bosh sahifaga qaytish</Button>
      </Link>
      {/* Karta global tema bilan moslashadi (yorug'/qorong'i) */}
      <div style={{ width: '100%', maxWidth: 500, background: 'var(--qk-card-bg)', color: 'var(--qk-text)', padding: '24px 20px', borderRadius: 15, boxShadow: '0 12px 40px rgba(0,0,0,0.25)', border: '1px solid var(--qk-border)', margin: '16px' }}>
        <Routes>
          <Route path="/login" element={<OldLogin />} />
          <Route path="/register" element={<OldRegister />} />
        </Routes>
      </div>
    </div>
  );
};

export default AuthLayout;
